const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
const SET_SEARCH = 'SET_SEARCH';
const SET_ORDER_BY = 'SET_ORDER_BY';
const SET_ACTIVE_COMPETITOR = 'SET_ACTIVE_COMPETITOR';

const state = {
  activeTab: 'opportunities',
  search: '',
  orderBy: 'competitorCount',
  orderDirection: 'desc',
  activeCompetitor: '',
};

const getters = {
  activeTab: ({activeTab}) => activeTab,
  search: ({search}) => search,
  orderBy: ({orderBy}) => orderBy,
  orderDirection: ({orderDirection}) => orderDirection,
  activeCompetitor: ({activeCompetitor}) => activeCompetitor,
};

const actions = {
  setActiveTab: ({commit}, tab) => commit(SET_ACTIVE_TAB, tab),
  setSearch: ({commit}, search) => commit(SET_SEARCH, search),
  setOrderBy: ({commit}, orderBy) => commit(SET_ORDER_BY, orderBy),
  setActiveCompetitor: ({commit}, competitor) => commit(SET_ACTIVE_COMPETITOR, competitor),
};

const mutations = {
  [SET_ACTIVE_TAB](state, tab) {
    state.activeTab = tab;
  },
  [SET_SEARCH](state, search) {
    state.search = search;
  },
  [SET_ACTIVE_COMPETITOR](state, competitor) {
    state.activeCompetitor = competitor;
  },
  [SET_ORDER_BY](state, orderBy) {
    if (orderBy === state.orderBy) {
      state.orderDirection = state.orderDirection === 'asc' ? 'desc' : 'asc';
      return;
    }
    state.orderBy = orderBy;
    state.orderDirection = 'asc';
  },
};

const backlinkOpportunity = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default backlinkOpportunity;
